import { useQuery } from "convex/react";
import { api } from "$convex/convexApi";
import { useAuthIdentity } from "@/contexts/UserProfileContext";

export function useCargos(limit = 1000) {
  const { isConvexAuthenticated } = useAuthIdentity();
  return useQuery(
    api.cargos.getCargos,
    isConvexAuthenticated ? { limit } : "skip",
  );
}

export function useCargosWithDetails(limit = 200, includeArchived = true) {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.admin.getCargosWithDetails,
    authUserId ? { authUserId, limit, includeArchived } : "skip",
  );
}

export function useCargo(cargoId?: string) {
  return useQuery(api.cargos.getCargo, cargoId ? { cargoId } : "skip");
}
